import React, { FunctionComponent, ReactNode } from 'react';
import LuxonUtils from '@date-io/luxon';
import CssBaseline from '@material-ui/core/CssBaseline';
import { ThemeProvider } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';

import { DesignSystemProvider } from '@shiftfinancial/design-system';
import { GlobalLoadingIndicator } from './components/GlobalLoadingIndicator';
import { StartupConfig } from './components/StartupConfig';
import StyledSnackBarProvider from './components/StyledSnackbarProvider';
import Mouseflow from './components/insights/Mouseflow';
import { TelemetryProvider } from './components/insights/TelemetryProvider';
import getCapitalTheme from './theme/themeOverride';

interface Props {
  children: ReactNode;
}

const GlobalWrapper: FunctionComponent<Props> = (props: Props) => {
  return (
    <>
      <StartupConfig>
        <TelemetryProvider>
          <Mouseflow />
          <DesignSystemProvider>
            <ThemeProvider theme={getCapitalTheme}>
              <StyledSnackBarProvider>
                <MuiPickersUtilsProvider utils={LuxonUtils}>
                  <GlobalLoadingIndicator />
                  <CssBaseline />
                  {props.children}
                </MuiPickersUtilsProvider>
              </StyledSnackBarProvider>
            </ThemeProvider>
          </DesignSystemProvider>
        </TelemetryProvider>
      </StartupConfig>
    </>
  );
};

export default GlobalWrapper;
